import { t } from './i18n.es.js';
import React, { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import { styled, thoundsandDelimiter, ButtonChevron, Row, Col, Button, Card, BlockHeader } from '@teko/ui';
import { __rest } from 'tslib';
import { O as OrderBy } from './types-3497cc60.js';
import { S as SelectOption } from './SelectOption-cd28985e.js';
import get from 'lodash.get';
import { J as JDDropdown } from './JDDropdown-97d5362f.js';
import { A as ActivatedFilters } from './ActivatedFilters-097114a2.js';

const Wrapper$2 = styled.div `
  position: relative;
  overflow: hidden;
`;
const StyledInput = styled.input `
  width: 100%;
  height: 2.1rem;
  line-height: 2.1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  z-index: 1;
  &:focus {
    outline: 0;
  }
`;
const PriceInput = (_a) => {
    var { value, placeholder, onChange, onEnter } = _a, props = __rest(_a, ["value", "placeholder", "onChange", "onEnter"]);
    const getValue = (value) => {
        const v = parseInt(value.replace(/[^0-9]/g, ''));
        const numberWithSeparator = isNaN(v) ? '' : thoundsandDelimiter(v);
        return {
            displayValue: numberWithSeparator,
            value: isNaN(v) ? 0 : v,
        };
    };
    const [val, setVal] = useState(getValue(value.toString()).displayValue);
    useEffect(() => {
        setVal(getValue(value.toString()).displayValue);
    }, [value]);
    return (React.createElement(Wrapper$2, Object.assign({}, props),
        React.createElement(StyledInput, { type: "text", maxLength: 14, placeholder: placeholder, value: val, onChange: (e) => {
                const { value } = getValue(e.target.value);
                if (onChange)
                    onChange(value);
            }, onKeyDown: (e) => {
                if (onEnter && e.keyCode === 13) {
                    const { value } = getValue(e.target.value);
                    onEnter(value);
                }
            } })));
};

const StyledOption$1 = styled(SelectOption)((props) => `
  margin-right: 1rem;
  cursor: pointer;
  color: ${props.isActive ? props.theme.brand.primary : ''};
  background-color: ${props.isActive ? props.theme.brand.tertiary : ''};
  padding: 0.5rem;
  &:hover {
    background: ${props.isActive ? '' : '#f3f3f3'};
  }
`);
const OptionName = styled.span `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const FilterPriceButton = styled.button((props) => `
  background: ${props.theme.brand.primary};
  border: none;
  color: #fff;
  padding: 0px 15px;
  border-radius: 4px;
  margin-left: 5px;
  visibility: visible;
  height: 2.1rem;
  line-height: 2.1rem;
  visibility: ${props.show ? 'visible' : 'hidden'};
`);
const Wrapper$1 = styled.div `
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  font-size: 14px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const FlexCenter = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;
const PriceRange = styled.div `
  height: 40px;
  line-height: 37px;
  padding: 0 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
const Title$2 = styled.div `
  margin-right: 2rem;
  font-weight: 600;
`;
const Flag = styled.div `
  position: absolute;
  top: -72px;
`;
const StyledPriceInput = styled(PriceInput) `
  width: 100px;
  margin: 0 10px;
`;
const stringToNumber = (str) => {
    const v = str.replace('/[^0-9]/g', '');
    return v ? parseInt(v) : 0;
};
const SortBar = ({ className, onClickOption, onSortByPrice, }) => {
    const currentQuery = useRouter().query;
    const [priceGte, setPriceGte] = useState();
    const [priceLte, setPriceLte] = useState();
    useEffect(() => {
        var _a, _b;
        setPriceLte(stringToNumber(((_a = currentQuery.price_lte) === null || _a === void 0 ? void 0 : _a.toString()) || ''));
        setPriceGte(stringToNumber(((_b = currentQuery.price_gte) === null || _b === void 0 ? void 0 : _b.toString()) || ''));
    }, [currentQuery.price_lte, currentQuery.price_gte]);
    const onSearch = (gte, lte) => {
        if (gte && lte && gte > lte) {
            setPriceLte(gte);
            setPriceGte(lte);
            lte = [gte, (gte = lte)][0];
        }
        onSortByPrice && onSortByPrice(gte, lte);
    };
    useEffect(() => {
        if (typeof window !== 'undefined' && currentQuery.page) {
            document.getElementById('js-sort-bar').scrollIntoView();
        }
    }, [currentQuery.page]);
    return (React.createElement(Wrapper$1, { className: className },
        React.createElement(Flag, { id: "js-sort-bar" }),
        React.createElement(FlexCenter, null,
            React.createElement(Title$2, null, t('Sắp xếp theo')),
            React.createElement(StyledOption$1, { stickySize: "sm", isActive: currentQuery.sort === 'SORT_BY_DISCOUNT_PERCENT', onClickOption: () => onClickOption &&
                    onClickOption('SORT_BY_DISCOUNT_PERCENT', OrderBy.DESC), "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-target": "searchProductResult", "data-content-name": "sort=discount&order=DESC", "data-content-payload": JSON.stringify({
                    screenName: 'searchProductResult',
                }) },
                React.createElement(OptionName, null, t('Khuyến mãi tốt nhất'))),
            React.createElement(StyledOption$1, { stickySize: "sm", activeBackground: "rgba(20, 53, 195, 0.08)", isActive: currentQuery.sort === 'SORT_BY_TOP_SALE_QUANTITY_90_DAYS', onClickOption: () => onClickOption &&
                    onClickOption('SORT_BY_TOP_SALE_QUANTITY_90_DAYS', OrderBy.DESC), "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-target": "searchProductResult", "data-content-name": "sort=quantity.last_3_month&order=DESC", "data-content-payload": JSON.stringify({
                    screenName: 'searchProductResult',
                }) },
                React.createElement(OptionName, null, t('Bán chạy'))),
            React.createElement(StyledOption$1, { stickySize: "sm", activeBackground: "rgba(20, 53, 195, 0.08)", isActive: currentQuery.sort === 'SORT_BY_PUBLISH_AT', onClickOption: () => onClickOption && onClickOption('SORT_BY_PUBLISH_AT', OrderBy.DESC), "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-target": "searchProductResult", "data-content-name": "sort=new&order=DESC", "data-content-payload": JSON.stringify({
                    screenName: 'searchProductResult',
                }) },
                React.createElement(OptionName, null, t('Mới về'))),
            React.createElement(StyledOption$1, { stickySize: "sm", activeBackground: "rgba(20, 53, 195, 0.08)", isActive: currentQuery.sort === 'SORT_BY_PRICE' &&
                    currentQuery.order === OrderBy.DESC, onClickOption: () => onClickOption && onClickOption('SORT_BY_PRICE', OrderBy.DESC), "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-target": "searchProductResult", "data-content-name": "sort=bestPrice&order=DESC", "data-content-payload": JSON.stringify({
                    screenName: 'searchProductResult',
                }) },
                React.createElement(OptionName, null, t('Giá giảm dần'))),
            React.createElement(StyledOption$1, { stickySize: "sm", activeBackground: "rgba(20, 53, 195, 0.08)", isActive: currentQuery.sort === 'SORT_BY_PRICE' &&
                    currentQuery.order === OrderBy.ASC, onClickOption: () => onClickOption && onClickOption('SORT_BY_PRICE', OrderBy.ASC), "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-target": "searchProductResult", "data-content-name": "sort=bestPrice&order=ASC", "data-content-payload": JSON.stringify({
                    screenName: 'searchProductResult',
                }) },
                React.createElement(OptionName, null, t('Giá tăng dần'))),
            React.createElement(PriceRange, null,
                React.createElement(StyledPriceInput, { value: priceGte || '', placeholder: t('Giá thấp nhất'), onChange: setPriceGte, onEnter: (value) => onSearch(value, priceLte) }),
                "-",
                React.createElement(StyledPriceInput, { value: priceLte || '', placeholder: t('Giá cao nhất'), onChange: setPriceLte, onEnter: (value) => onSearch(priceGte, value) }),
                React.createElement(FilterPriceButton, { "data-track-content": true, "data-content-region-name": "sortFilterProduct", "data-content-name": "applyFilter", "data-content-target": "searchProductResult", "data-content-payload": JSON.stringify(Object.assign(Object.assign({ screenName: 'searchProductResult' }, (priceLte ? { priceLte } : {})), (priceGte ? { priceGte } : {}))), show: !!priceLte || !!priceGte, onClick: () => onSearch(priceGte, priceLte) }, t('Tìm'))))));
};

const Wrapper = styled.div `
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 0.8px solid #e0e0e0;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-top: 0.3rem;
  float: right;
`;
const StyledButton = styled(ButtonChevron) `
  padding: 5px;
  margin: 0;
  position: relative;
  top: 2px;
`;
const ShowMoreBtn = ({ setIsActive, isActive, }) => {
    return (React.createElement(Wrapper, { onClick: () => setIsActive(!isActive) },
        React.createElement(StyledButton, { link: true, direction: isActive ? 'up' : 'down' })));
};

const Title$1 = styled.div `
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledOption = styled(SelectOption)((props) => `
    margin-right: 0.5rem;
    margin-bottom: 0.3rem;
    padding: 0.375rem 1.25rem;
    color: ${props.isActive ? props.theme.brand.primary : '#333'};
    cursor: pointer;
    &:hover {
      background: #f3f3f3;
    }
  `);
const StyledRow$1 = styled(Row) `
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const StyledShowMoreBtn = styled(ShowMoreBtn) `
  margin-top: 0.3rem;
  float: right;
`;
const ListOption = styled(Col) `
  height: ${(props) => props.isShowMore ? 'auto' : '2.5rem'};
  overflow: hidden;
`;
const FilterRow = ({ value, filter, onClickOption, }) => {
    const [isShowMore, setIsShowMore] = useState(false);
    const [isHideButtonShowMore, setIsHideButtonShowMore] = useState(false);
    const isSelected = useCallback((filterValue) => {
        if (!value) {
            return false;
        }
        return !!~value.split(',').indexOf(filterValue.optionCode);
    }, [value]);
    useEffect(() => {
        var _a;
        const height = ((_a = document.getElementById(`js-${filter.code}`)) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
        if (height < 90) {
            setIsHideButtonShowMore(true);
        }
    }, []);
    return (React.createElement(StyledRow$1, null,
        React.createElement(Col, { col: 1.5 },
            React.createElement(Title$1, null, filter.name)),
        React.createElement(ListOption, { isShowMore: isShowMore, col: 10 },
            React.createElement("div", { id: `js-${filter.code}` }, filter.options.map((option, index) => (React.createElement(StyledOption, { activeBackground: "#fff", isActive: isSelected(option), onClickOption: () => onClickOption && onClickOption(option), key: index, stickySize: "sm" }, option.optionName))))),
        React.createElement(Col, { col: 0.5 }, !isHideButtonShowMore && (React.createElement(StyledShowMoreBtn, { isActive: isShowMore, setIsActive: setIsShowMore })))));
};

const Title = styled.div `
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledRow = styled(Row) `
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const DropdownOption = styled(JDDropdown) `
  max-width: 19%;
  margin-right: 0.5rem;
`;
const AdvancedFilterRow = ({ filters, onClickOption, activeValues = [], }) => {
    return (React.createElement(StyledRow, null,
        React.createElement(Col, { col: 1.5 },
            React.createElement(Title, null, t('Bộ lọc nâng cao'))),
        React.createElement(Col, { col: 10.5 }, filters.slice(5, 10).map((filter, index) => {
            return (React.createElement(DropdownOption, { count: activeValues.filter((value) => value.filterCode === filter.code)
                    .length, text: filter.name, key: index },
                React.createElement(React.Fragment, null, filter.options.map((option, index) => (React.createElement(Button, { key: index, link: true, onClick: () => {
                        if (onClickOption) {
                            onClickOption(option);
                        }
                    }, variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === option.optionCode) !== -1
                        ? 'primary'
                        : 'normal' }, option.optionName))))));
        }))));
};

const ListFilters = styled.div `
  padding: 1rem;
`;
const StyledCard = styled(Card) `
  width: 100%;
  overflow: unset;
`;
const Filter = ({ filters, onClickOption, query, activeFilters = [], clearFilterLink, }) => (React.createElement(StyledCard, null,
    React.createElement(BlockHeader, { content: React.createElement(ActivatedFilters, { onClick: onClickOption, activeValues: activeFilters }), title: t('Bộ lọc'), actionLink: (activeFilters.length && {
            href: clearFilterLink || '#',
            title: t('Xóa bộ lọc'),
            color: '#ef2741',
            hideIcon: true,
            regionName: 'headerFilter',
            contentName: 'resetFilter',
        }) ||
            undefined }),
    React.createElement(ListFilters, null,
        filters.slice(0, 5).map((filter, index) => {
            const value = () => {
                return (get(query, filter.code) ||
                    get(query, ['dynamicFields', filter.code]));
            };
            return (React.createElement(FilterRow, { value: value(), onClickOption: onClickOption, key: index, filter: filter }));
        }),
        filters.length > 5 && (React.createElement(AdvancedFilterRow, { activeValues: activeFilters, onClickOption: onClickOption, filters: filters })))));

export { AdvancedFilterRow as A, Filter as F, PriceInput as P, SortBar as S, FilterRow as a, ShowMoreBtn as b };
